import { styled } from '@mui/material';

export const Title = styled('div')({
  color: '#252733',
  fontSize: 14,
});

export const Text = styled('span')({
  color: '#858585',
  fontSize: 14,
});

export const Details = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const CompanyName = styled(Title)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 4,
  marginTop: 12,
  minWidth: 0,
  '& > span:first-of-type': {
    flexShrink: 0,
  },
});

export const CompanyNameValue = styled(Text)({
  flex: 1,
  minWidth: 0,
});
